import { useNavigate } from "react-router-dom";
import { IndorImages, getIndorImageSrc } from "../../features";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { PathInRoadItem } from "./PathInRoadItem";
import { highlightSearchValueInText } from "../../features/textHighlighter/textHighlighter";
import { classNames } from "primereact/utils";

const goToCardButtonIconSrc = getIndorImageSrc(IndorImages.MessageInfo);
const itemIsExpandedIcon = require('../../assets/images/icons/down_icon_dark.png')
const itemIsNotExpandedIcon = require('../../assets/images/icons/forward_icon.png')

type RoadWithPathsItemProps = {
    roadId: string,
    roadName: string,
    paths: any,
    isInRaion: boolean,
    raionId?: string
}

// Компонент - объект с наименованием дороги и направления на странице "Выбор дорог и направлений"
export function RoadWithPathsItem({ roadId, roadName, paths, isInRaion, raionId }: RoadWithPathsItemProps) {
    const navigate = useNavigate()
    const { selectedPath, pathsSearchValue } = useAppSelector(state => state.pathsInfo)
    const [isExpanded, setIsExpanded] = useState<boolean>(roadId == selectedPath?.roadId)

    function goToCard() {
        navigate(`/app/road/${roadId}`)
    }

    useEffect(() => {
        if (pathsSearchValue) {
            setIsExpanded(true)
        }
    }, [pathsSearchValue])

    const roadClassnames = classNames({
        "roads-list-road-item": true,
        "in-raion": isInRaion
    })

    return (
        <>
            <div className={roadClassnames} onClick={() => setIsExpanded(!isExpanded)}>
                {isInRaion && <div className="in-raion-mark-div" />}
                <img className={"expand-state-icon" + (isExpanded ? ' expanded' : ' not-expanded')} src={isExpanded ? itemIsExpandedIcon : itemIsNotExpandedIcon} />
                <span>{highlightSearchValueInText(roadName, pathsSearchValue)}</span>
                <div className='navigation-buttons'>
                    <img className='go-to-card-button' onClick={goToCard} src={goToCardButtonIconSrc} />
                </div>
            </div>
            {isExpanded &&
                <div>
                    {paths.map((path: any) =>
                        <PathInRoadItem path={path} isInRaion={isInRaion} raionId={raionId}/>
                    )}
                </div>
            }
        </>
    );
}

